import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from '../../hooks';
import {selectTasks, fetchTasksByFirm, selectTasksLoading, selectTasksError} from './tasksSlice';
import {RootState} from '../../store';
import {useNavigate} from 'react-router-dom';

const TasksList: React.FC = () => {
    const dispatch = useAppDispatch();
    const tasks = useAppSelector(selectTasks);
    const loading = useAppSelector(selectTasksLoading);
    const error = useAppSelector(selectTasksError);
    const firmId = useAppSelector((s: RootState) => s.user.firm?.idt);

    const navigate = useNavigate();

    // Charge à l’ouverture et quand la firme change
    useEffect(() => {
        if (firmId) {
            dispatch(fetchTasksByFirm()).unwrap().catch((err) => {
                if (err?.message?.startsWith("498")) {
                    navigate('/login');
                }
            });
        }
    }, [dispatch, firmId, navigate]);

    if (!firmId) return <div>Aucune firme sélectionnée.</div>;
    if (loading) return <div>Chargement des tâches…</div>;
    if (error) return <div>Erreur : {error}</div>;
    if (!tasks.length) return <div>Aucune tâche pour le moment.</div>;

    return (
        <ul>
            {tasks.map(t => (
                <li key={t.idt}>
                    <h1>#{t.num} - {t.title}</h1>
                    <h3>{t.priority}</h3>
                    {t.dueDate && <span>{new Date(t.dueDate).toLocaleString()}</span>}
                    <p>{t.description}</p>
                </li>
            ))}
        </ul>
    );
};

export default TasksList;
